import React from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Back from 'assets/images/svg/back_blue.svg'
import ActivationFile from '../component/activationFile'
import { useModal } from 'hooks'
import CancelSubscription from '../component/cancelSubscription'
import { useAddonById } from 'hooks/use-products'
import { downloadFile, json } from 'helpers/data'
import moment from 'moment'
import _productService from 'services/products-services'
import { toast } from 'react-toastify'
import { t } from 'i18next'
import { useQueryClient } from 'react-query'
const AddonDetailsMange = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const queryClient = useQueryClient()

    const addonSubscriptionId = searchParams.get("addonSubscriptionId");
    const {productsAddon}  =useAddonById(addonSubscriptionId)
    const [showCancelSubScription, openCancelSubscription, closeACancelSubscription] = useModal(false);
    const [showActivationFile, openActivationFile, closeActivationFile] = useModal(false);

    const success = () => {
        toast.success(t('common:form.renew'))
        queryClient.invalidateQueries(['addon-details'])

      };
    const renewAddonEx = (data)=>{
        const renewActive={
            versionSubscriptionId: data?.versionSubscriptionId,
            addOnSubscriptionId: addonSubscriptionId,
            licenseId: data?.licenseId
        }
        _productService.renewAddonExpire(renewActive).then(success)
    }
    
    return (
        <div className="settings myApps addonDetailMange">
            <div className="header">
                <div className="page-name">
                    <button  className='border-0' onClick={()=> navigate(-1)}>
                        <img src={Back} alt="back" />
                    </button>
                    <h1>{json(productsAddon?.addonTitle)}</h1>
                </div>
            </div>
            <hr className="hr" />

            <div className='manage'>
                <div className='row'>
                    <div className='col-xl-4'>
                        <div className='manageBox'>
                            <h1 className='title'>{t("browse-apps:myProducts.managePage.manageAddon")}</h1>
                            <p className='purchased'>{t("browse-apps:myProducts.addonPage.purchased")}: <span>{moment(productsAddon?.purchasedDate).format('DD/MM/YYYY')}</span></p>
                            <div className='d-flex justify-content-between'>
                            <p className='next'> {t("browse-apps:myProducts.managePage.newtRenewal")}:<span>{moment(productsAddon?.renewalDate).format('DD/MM/YYYY')}</span> <span className='span-danger'> {productsAddon?.renewalDate < moment.utc().format() && '{t("browse-apps:myProducts.addonPage.expired")}'}</span></p>
                            <Link to="/invoices/unpaid">   {t("browse-apps:myProducts.addonPage.goUpPaidInvo")}</Link>
                            </div>
                            <p className='content'>{t("browse-apps:myProducts.managePage.manageInfo")}</p>
                            {productsAddon?.licenseStatusId === 0 && ( <button className='btn-blue' onClick={openActivationFile}> {t("browse-apps:myProducts.addonPage.generate")}</button> )}
                            {productsAddon?.licenseStatusId === 3 && ( <button className='btn-blue' onClick={()=> renewAddonEx(productsAddon)}>{t("browse-apps:myProducts.managePage.renewAddon")}</button> )}
                           {productsAddon?.licenseStatusId === 1 && (<button className='btn-dimmed'>{t("browse-apps:myProducts.addonPage.inProgress")}</button>) } 
                           {productsAddon?.licenseStatusId === 2 && ( <button className='btn-border' onClick={()=>downloadFile(productsAddon?.file)}>  {t("browse-apps:myProducts.addonPage.downloadFile")}</button>)}
                           {productsAddon?.canCancelSubscription  && ( <button className='btn-White' onClick={openCancelSubscription}>{t("browse-apps:myProducts.managePage.cancelSubscription")}</button>)}
                        </div>
                    </div>
                </div>
                 <ActivationFile show={showActivationFile} onHide={closeActivationFile} addOnId={addonSubscriptionId} />
                 <CancelSubscription show={showCancelSubScription} onHide={closeACancelSubscription} addon />
            </div>
        </div>
    )
}

export default AddonDetailsMange